import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Trophy } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import api from '@/lib/api';
import { PublicHeader, PublicFooter } from '@/components/PublicShell';
import { formatDateShortPt } from '@/components/Badges';

export default function ResultsPage() {
  const [results, setResults] = useState([]);
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    api.get('/public/results').then((r) => setResults(r.data));
    api.get('/public/settings').then((r) => setSettings(r.data));
  }, []);

  return (
    <div>
      <PublicHeader />
      <div className="mx-auto max-w-6xl px-4 sm:px-6 py-10">
        <div className="font-display text-4xl text-white">RESULTADOS</div>
        <p className="text-muted-foreground">Todas as etapas finalizadas do campeonato.</p>
        <div className="mt-3">
          <Link to="/resultados/repescagem" className="text-sm text-[var(--g66-amber)] hover:underline">Ver ranking de repescagem →</Link>
        </div>

        {results.length === 0 ? (
          <div className="text-center py-16 text-muted-foreground">Nenhuma etapa finalizada ainda.</div>
        ) : (
          <div className="mt-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {results.map((s) => (
              <Link key={s.id} to={`/etapas/${s.slug}`} data-testid={`result-item-${s.slug}`}>
                <Card className="card-hover border border-border bg-card h-full">
                  <CardContent className="p-5">
                    <div className="text-xs text-muted-foreground">{formatDateShortPt(s.date)}</div>
                    <div className="font-semibold text-white mt-1">{s.title}</div>
                    <div className="mt-4 flex items-center gap-2">
                      <Trophy className="w-5 h-5 text-[var(--g66-amber)]" />
                      <span className="font-display text-2xl text-[var(--g66-amber)]">{s.winner_band?.name || '-'}</span>
                    </div>
                    <div className="mt-3 text-sm text-white/90">
                      <div className="flex justify-between">
                        <span>{s.band_a?.name}</span>
                        <span>{s.band_a_votes || 0} • {s.band_a_percentage?.toFixed?.(1) || 0}%</span>
                      </div>
                      <div className="flex justify-between">
                        <span>{s.band_b?.name}</span>
                        <span>{s.band_b_votes || 0} • {s.band_b_percentage?.toFixed?.(1) || 0}%</span>
                      </div>
                    </div>
                    <div className="mt-2 text-xs text-muted-foreground">Total: {s.total_votes || 0} votos</div>
                  </CardContent>
                </Card>
              </Link>
            ))}
          </div>
        )}
      </div>
      <PublicFooter settings={settings} />
    </div>
  );
}
